export const LANDING = '/';
export const SIGN_IN = '/signin';
